/**
 * @module experience/landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
// Core Libraries
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { ContentProviderService } from '@core/aem/services/content-provider.service';

// Interfaces
import { ConfigurableLineSelectorAEMData } from '@experience/landing/common/components/line-selector/interfaces/line-selector.interface';
import { StaticModal } from '@support/shared/widgets/interfaces/static-modal.interface';

// Constants
import { PLAN_SERVICES_CONSTANTS } from '@experience/landing/common/constants/line-details.constants';
import { map } from 'rxjs/operators';
/**
 * line selector component
 */

@Injectable()
export class LineSelectorService {
  /**
   * Static modal for cancellation status pop up in retail and care
   */
  public modal: StaticModal;
  /**
   * holds the previous Url for Line selector Page
   */
  public previousUrl: string;

  constructor(private contentProviderService: ContentProviderService) {}

  /**
   * Method for getting content data for line details
   * @returns object
   */
  public getLineSelectorContentData(): Observable<object> {
    return this.contentProviderService.getContentData().pipe(
      map((contentData: ConfigurableLineSelectorAEMData) => {
        return this.contentProviderService.getConfigurableData(contentData);
      })
    );
  }

  /**
   * Fetches the modal content
   * @return editOrderModalObject
   */
  public cancelOrderModalObject(aemData: ConfigurableLineSelectorAEMData): StaticModal {
    const cancelOrderModalData: StaticModal = {
      headerText: aemData.changesWillBeLost,
      bodyText: aemData.changesWIllBeLostWarning,
      disableDismiss: false,
      modalName: 'cancel-order-modal',
      disableEsc: false,
      buttons: [
        {
          id: PLAN_SERVICES_CONSTANTS.CONTINUE,
          type: PLAN_SERVICES_CONSTANTS.SUBMIT,
          name: aemData.continue,
          class: PLAN_SERVICES_CONSTANTS.BUTTON_CLASS_PRIMARY,
          disabled: false,
        },
      ],
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: true,
    };
    return cancelOrderModalData;
  }
}
